import { Grid, Typography, Box } from "@mui/material";
import { ModuleGameStatus, SelectedGame } from "entities/modules/types";
import { useState } from "react";
import RandomTypeItem from "shared/components/RandomTypeItem";
import { COLOR_BLACK, COLOR_GREY_8 } from "shared/theme/colors";
import { EyeOffIcon } from "shared/theme/icons/EyeOffIcon";
import { EyeOnIcon } from "shared/theme/icons/EyeOnIcon";
import NoTableItemsMessage from "../Table/NoTableItemsMessage";
import {
  StyledGrid,
  StyledHeaderContainer,
  StyledStatus,
  StyledText,
} from "./styled";

type Props = {
  selectedGames: SelectedGame[];
  setSelectedGames: (games: SelectedGame[]) => void;
};

const RandomSelectedGamesList = ({
  selectedGames,
  setSelectedGames,
}: Props) => {
  const [hoveredRowId, setHoveredRowId] = useState<string>();

  const toggleGameStatus = (gameId: string) => {
    setSelectedGames(
      selectedGames.map((game) => {
        if (game.id === gameId) {
          const newStatus =
            game.status === ModuleGameStatus.Active
              ? ModuleGameStatus.Hidden
              : ModuleGameStatus.Active;
          return { ...game, status: newStatus };
        }
        return game;
      }),
    );
  };

  return (
    <Box mt="1rem">
      {!selectedGames.length ? (
        <Box>
          <NoTableItemsMessage message="No games found" />
        </Box>
      ) : (
        <>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <StyledHeaderContainer>
                <StyledText>
                  <Typography variant="bodyMSemiBold" color={COLOR_BLACK}>
                    Name
                  </Typography>
                </StyledText>
              </StyledHeaderContainer>
            </Grid>
            <Grid item xs={4}>
              <StyledHeaderContainer>
                <StyledText>
                  <Typography variant="bodyMSemiBold" color={COLOR_BLACK}>
                    Studio
                  </Typography>
                </StyledText>
              </StyledHeaderContainer>
            </Grid>
            <Grid item xs={2}>
              <StyledHeaderContainer>
                <StyledText>
                  <Typography variant="bodyMSemiBold" color={COLOR_BLACK}>
                    Visibility
                  </Typography>
                </StyledText>
              </StyledHeaderContainer>
            </Grid>
          </Grid>
          {selectedGames
            .sort((a, b) => a.order - b.order)
            .map((item, index) => {
              const isFirst = index === 0;
              const isLast = index === selectedGames.length - 1;
              const isHidden = item.status === ModuleGameStatus.Hidden;
              const isRowHovered = hoveredRowId === item.id;

              return (
                <StyledGrid
                  container
                  spacing={0}
                  key={item.id}
                  isHidden={isHidden}
                  onMouseEnter={() => setHoveredRowId(item.id)}
                  onMouseLeave={() => setHoveredRowId("")}
                >
                  <Grid item xs={6}>
                    <RandomTypeItem
                      key={item.id}
                      isFirst={isFirst}
                      isLast={isLast}
                      value={item.name}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <RandomTypeItem
                      key={item.id}
                      isFirst={isFirst}
                      isLast={isLast}
                      value={item.studioName ?? "-"}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <RandomTypeItem
                      key={item.id}
                      isFirst={isFirst}
                      isLast={isLast}
                      value={item.status ?? "-"}
                      height="21px"
                    >
                      <StyledStatus
                        isHovered={isRowHovered || isHidden}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleGameStatus(item.id);
                        }}
                      >
                        {isHidden ? (
                          <EyeOffIcon color={COLOR_GREY_8} />
                        ) : (
                          <EyeOnIcon color={COLOR_GREY_8} />
                        )}
                      </StyledStatus>
                    </RandomTypeItem>
                  </Grid>
                </StyledGrid>
              );
            })}
        </>
      )}
    </Box>
  );
};

export default RandomSelectedGamesList;
